<div class="base-component component-white">
  <div fxFill.lt-md fxLayoutAlign="space-between center">
    <h4 class="text-hard-blue">Adicionar Resposta</h4>

    <div>
      <app-call-files
        (filesIncuded)="filesIncuded($event)"
      ></app-call-files>
    </div>
  </div>
  <mat-spinner *ngIf="saving" diameter="20"></mat-spinner>
  <br>
  <ckeditor
    [config]="{
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'undo',
        'redo'
      ]
    }"
    [editor]="entryEditor"
    [(ngModel)]="description"
  ></ckeditor>
  <br>

  <div *ngIf="filesToUpload">
    <div><h5 class="font-primary">Arquivos Anexados</h5></div>
    <div
      *ngFor="let file of filesToUpload"
      fxLayout="column"
      fxLayoutGap="5px"
    >
    <div fxLayout="row" fxLayoutAlign="space-between center" class="file-div">
      <small>
        {{file.name}}
      </small>
      <button mat-button color="warn" (click)="removeFile(file)">
        <mat-icon>close</mat-icon> Remover
      </button>
    </div>
    </div>
  </div>

  <br>
  <div 
    fxLayout.lt-md="column" 
    fxLayoutGap="5px" 
    fxLayoutAlign="space-between center" 
    fxLayoutAlign.lt-md="space-between start"
  >
    <div>
      <mat-form-field *ngIf="operator">
        <mat-label>Tipo de Resposta</mat-label>
        <mat-select [(ngModel)]="typeResponse">
          <mat-option value="R">Resposta</mat-option>
          <mat-option value="C">Compromisso</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="operator && typeResponse != 'R'">
        <mat-label>Data Limite</mat-label>
        <input
          matInput
          [(ngModel)]="limitDate"
          type="date"
        />
      </mat-form-field>
    </div>
    <div fxLayoutGap="10px" fxLayoutAlign="space-between center">
      <button
        *ngIf="operator"
        mat-raised-button
        [disabled]="saving"
        (click)="openOsCreation()"
        color="basic"
      >Abrir Ordem de Serviço</button>
      <button
        mat-raised-button
        [disabled]="saving"
        (click)="saveEntry()"
        color="primary"
      >Responder</button>
    </div>
  </div>
</div>
